import { memo, useCallback } from 'react';

import type { WorkItem } from '../common/models';
import { SearchResultRow } from '../components';
import { workItemTypeAccent } from './workItemColors';

export type WorkItemResultRowProps = {
    item: WorkItem;
    selected: boolean;
    onSelect: (item: WorkItem) => void;
};

export const WorkItemResultRow = memo(function WorkItemResultRow({ item, selected, onSelect }: WorkItemResultRowProps) {
    const handleSelect = useCallback(() => onSelect(item), [onSelect, item]);
    return (
        <SearchResultRow
            id={item.id}
            title={item.title}
            accent={workItemTypeAccent(item.workItemType, item.title)}
            typeLabel={item.workItemType}
            selected={selected}
            onSelect={handleSelect}
        />
    );
});
